/**
 * Function for generating unique IDs that can be passed to accessibility attributes
 * @param {string} prefix
 */
export const generateId = (prefix: string): string => {
    return (
        prefix +
        Math.random().toString(36).substring(2, 5) +
        Math.random().toString(36).substring(2, 5)
    );
};
